import { TYPES } from "./draft_bailiff.type";
import { doc, onSnapshot, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/bailiff/api";

// ========= firebase function =========//

const STATUS = ["approval", "ready for forwarding"];
//snap all provider
const allDraftBailiffSub = [];
export const snapDraftBailiff = (callback) => (dispatch) => {
  setDraftBailiffAllSuccess(dispatch, null);
  const cRef = getRefs().bailiff;
  const c0 = where("status", "in", STATUS);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log({ data });
      setDraftBailiffAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDraftBailiffSub.push(unsub);
};

export const unSnapDraftBailiff = () => (dispatch) => {
  allDraftBailiffSub.forEach((subscriber) => {
    subscriber();
  });
  allDraftBailiffSub.length = 0;
};

// snap detail bailiff
const allDraftBailiffDetailSub = [];
export const snapDraftBailiffDetail =
  ({ bailiffId }, callback) =>
  (dispatch) => {
    setDraftBailiffDetailSuccess(dispatch, null);
    const cRef = getRefs().bailiff;
    const dRef = doc(cRef, bailiffId);
    const unsub = onSnapshot(dRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.data();
        setDraftBailiffDetailSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    allDraftBailiffDetailSub.push(unsub);
  };

export const unSnapDraftBailiffDetail = () => (dispatch) => {
  allDraftBailiffDetailSub.forEach((subscriber) => {
    subscriber();
  });
  allDraftBailiffDetailSub.length = 0;
};

// ========= cloud function =========//
// :::: forward đoạn văn :::::://
export const forwardClient =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.fordWardDialog;
    const options = { id };
    console.log({ options });
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };
// ========= local function =========//
export const setDraftBailiffAll = (data, callback) => (dispatch) => {
  setDraftBailiffAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffOpenAdd = (data, callback) => (dispatch) => {
  setDraftBailiffOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffOpenEdit = (data, callback) => (dispatch) => {
  setDraftBailiffOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffSelected = (data, callback) => (dispatch) => {
  setDraftBailiffSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffSearch = (data, callback) => (dispatch) => {
  setDraftBailiffSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffOpenForward = (data, callback) => (dispatch) => {
  setDraftBailiffOpenForwardSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffMerge = (data, callback) => (dispatch) => {
  setDraftBailiffMergeSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftBailiffSpeakers = (data, callback) => (dispatch) => {
  setDraftBailiffSpeakersSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDraftBailiffAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_ALL,
    payload: data,
  });
};

const setDraftBailiffOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_OPEN_ADD,
    payload: data,
  });
};

const setDraftBailiffOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_OPEN_EDIT,
    payload: data,
  });
};

const setDraftBailiffSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_SELECTED,
    payload: data,
  });
};

const setDraftBailiffSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_SEARCH,
    payload: data,
  });
};

const setDraftBailiffDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_DETAIL,
    payload: data,
  });
};

const setDraftBailiffOpenForwardSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_OPEN_FORWARD,
    payload: data,
  });
};

const setDraftBailiffMergeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_MERGE,
    payload: data,
  });
};

const setDraftBailiffSpeakersSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_BAILIFF_SPEAKERS,
    payload: data,
  });
};
